import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AddCampaign } from "./addcampaign/addcampaign.component";
import { AddPromotionComponent } from "./addpromotion/addpromotion.component";
import { AddaddupsellingComponent } from "./addupselling/addupselling.component";
import { CampaignsComponent } from "./campaigns/campaigns.component";
import { PromotionNotificationComponent } from "./promotionnotification/promotionnotification.component";
import { UpsellingComponent } from "./upselling/upselling.component";
import { UserManagerComponent } from "./usermanager/usermanager.component";
import { ScreenMappingComponent } from "./screenmapping/screenmapping.component";
import { BannersComponent } from './banners/banners.component';
import { AddBannerComponent } from "./addbanner/addbanner.component";


const mainRoutes: Routes = [

    { path: 'campaigns', component: CampaignsComponent },
    { path: 'addcampaign', component: AddCampaign },
    { path: 'upselling', component: UpsellingComponent },
    { path: 'addupselling', component: AddaddupsellingComponent },
    { path: 'promotionnotification', component: PromotionNotificationComponent },
    { path: 'addpromotion', component: AddPromotionComponent },
    { path: 'usermanager', component: UserManagerComponent },
    { path: 'screenmapping', component: ScreenMappingComponent },
    { path: 'banners', component: BannersComponent },
    { path: 'addbanner', component: AddBannerComponent }

]
@NgModule({
    imports: [RouterModule.forChild(mainRoutes)],
    exports: [RouterModule]
})
export class UtilitiesRoutingModule {

}